import { NewsParam } from 'common/types/params'
import { ArticleDetailState, NewsState } from 'common/types/entities/news'
import { axios } from 'common/utils'
import { ArticleDetailParam } from 'common/types/params/news/articleDetail'
import { SubVertical } from 'common/constants'
import { fetchStoreNewsByNewsParam } from 'common/services/list'

export async function fetchNews(newsParam: NewsParam): Promise<NewsState> {
  const { branchId, storeId } = newsParam

  let url = ''
  if (storeId) {
    url = `/v1/channels/${storeId}/news`
  } else if (branchId) {
    url = `/v1/branch/${branchId}/news`
  }

  const result = await axios.get(url, {
    params: newsParam,
  })
  return result && { ...result.data, contentType: newsParam.contentType, storeId: newsParam.storeId }
}

export async function fetchArticleDetail(param: ArticleDetailParam): Promise<ArticleDetailState> {
  let url = ''
  const { storeId, firstRelatedProductId, branchId, newsId } = param
  if (storeId) {
    url = `/v1/channels/${storeId}/news/${newsId}?firstRelatedProductId=${firstRelatedProductId || ''}`
  } else if (branchId) {
    url = `/v1/branch/${branchId}/news/${newsId}?firstRelatedProductId=${firstRelatedProductId || ''}`
  }

  const result = await axios.get<ArticleDetailState>(url)
  return result && result.data
}

export async function fetchNewsBySubVerticalAtEvent(newsParam: NewsParam): Promise<NewsState> {
  const { subVertical } = newsParam
  if (subVertical === SubVertical.DEPARTMENT || subVertical === SubVertical.OUTLET) {
    const result = await axios.get('/v1/branch/news', {
      params: newsParam,
    })
    return result && { ...result.data }
  }

  return await fetchStoreNewsByNewsParam(newsParam)
}
